import { useTranslation } from 'react-i18next';
import { Box, styled, useTheme } from '@mui/material';
import { IconLock } from '@tabler/icons-react';

import { NonIdealState, Typography } from '@zendesk/forethought-elements';

export default function ChannelAccessDeniedState({
  withPanel = false,
}: {
  /** Render on the white rounded panel used for content on dark pages. */
  withPanel?: boolean;
}) {
  const { t } = useTranslation('app');
  const { palette } = useTheme();

  const state = (
    <Container>
      <NonIdealState
        icon={
          <IconContainer>
            <IconLock
              color={palette.colors.primary[500]}
              size={48}
              stroke={2}
            />
          </IconContainer>
        }
        title={t('channelAccessDenied.title')}
      >
        <Typography color={palette.colors.grey[700]} variant='font16'>
          {t('channelAccessDenied.description')}
        </Typography>
      </NonIdealState>
    </Container>
  );

  if (!withPanel) {
    return state;
  }

  return (
    <Box
      sx={{
        bgcolor: palette.colors.white,
        borderRadius: '24px 24px 0 0',
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
      }}
    >
      {state}
    </Box>
  );
}

const Container = styled('div')`
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: center;
  padding: 80px 40px;
`;

const IconContainer = styled('div')`
  height: 48px;
  width: 48px;
`;
